/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

// react and redux
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
// Actions
import { getLessonPages, getListing } from "../../../actions";
// BASE Componets
import _ from "../../../../@lodash";
import BASELoading from "../../../../@BASE/core/BASELoading";
import BASEPageSimple from "../../../../@BASE/core/BASEPageSimple";
import useThemeMediaQuery from "../../../../@BASE/hooks/useThemeMediaQuery";
// material-ui components
import { styled } from "@mui/material/styles";
// custom components
import ExportHeader from "../../../shared-components/headers/ExportHeader";
import AnswerKeyHeader from "../../../shared-components/AnswerKeyHeader";
import { Storyboard } from "../../../shared-components/Storyboard";
// styles to add to the page layout
const Root = styled(BASEPageSimple)(({ theme }) => ({
  "& .BASEPageSimple-header": {
    backgroundColor: theme.palette.background.royalBlue,
    color: theme.palette.getContrastText(theme.palette.primary.main),
  },
  "& .html-reset ul, & .html-reset ol": {
    listStyle: "auto",
    margin: "revert",
    padding: "revert",
  },
}));

const LessonStoryboard = () => {
  const [storyboard, setStoryboard] = useState(null);
  const [templates, setTemplates] = useState(null);
  // dispatch
  const dispatch = useDispatch();
  // route params
  const routeParams = useParams();
  // redux state
  const isMobile = useThemeMediaQuery((theme) => theme.breakpoints.down("lg"));

  const setLessonPages = async () => {
    try {
      const response = await dispatch(getLessonPages(routeParams.id)).unwrap();
      setStoryboard(response);
    } catch (error) {
      console.error("Failed to fetch lesson pages:", error);
    }
  };

  const handleGetTemplates = async () => {
    try {
      const response = await dispatch(getListing("templates")()).unwrap();
      setTemplates(response);
    } catch (err) {
      setError(err.message);
    }
  };

  useEffect(() => {
    setLessonPages();
    handleGetTemplates();
  }, [routeParams.id]);

  // if export is null return loading
  if (!storyboard || !templates) {
    return <BASELoading />;
  }

  return (
    <Root
      header={
        <ExportHeader
          title="Lesson Storyboard"
          resource="lessons"
          back="Lessons"
        />
      }
      content={<Storyboard lesson={storyboard} templates={templates} />}
      scroll="normal"
    />
  );
};

export default LessonStoryboard;
